import Datetime from 'utils/datetime/datetime'

export function createIntradayHourLabel(index: number): string {
  const now = new Date()
  now.setMinutes(0, 0, 0)
  now.setHours(now.getHours() + 1)

  const start = new Date(now)
  start.setHours(now.getHours() + index)
  const end = new Date(start)
  end.setHours(start.getHours() + 1)

  const startHour = start.getHours().toString().padStart(2, '0')
  const endHour = end.getHours().toString().padStart(2, '0')
  const startDate = Datetime.toLocalTime(Datetime.toISOString(start), 'onlyDate')
  const endDate = Datetime.toLocalTime(Datetime.toISOString(end), 'onlyDate')

  if (startDate === endDate) {
    return `${startDate} ${startHour}:00-${endHour}:00`
  }

  return `${startDate} ${startHour}:00 - ${endDate} ${endHour}:00`
}
